var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    { staticClass: "px-3" },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "header-sticky" },
        [
          _c(
            "v-card",
            {
              staticClass: "w-100 rounded-lg settings-card",
              attrs: {
                color: _vm.$vuetify.theme.dark ? "#2E2E2E" : "white",
                "min-width": "640",
                width: "100%",
                elevation: "4",
              },
            },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "start", "no-gutters": "" } },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "pr-2", attrs: { large: "" } },
                        [_vm._v("mdi-cog")]
                      ),
                      _c("h3", [_vm._v(_vm._s(_vm.$t("settingsTitle")))]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "px-4 settings-content" },
                [
                  _c(
                    "v-tabs",
                    {
                      staticClass: "mb-6",
                      attrs: {
                        "show-arrows": "",
                        "background-color": _vm.$vuetify.theme.dark
                          ? "#2E2E2E"
                          : "white",
                      },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c("v-tab", [
                        _vm._v(_vm._s(_vm.$t("settingsTabGeneral"))),
                      ]),
                      _c("v-tab", [
                        _vm._v(_vm._s(_vm.$t("settingsTabSecurity"))),
                      ]),
                      _c("v-tab", [
                        _vm._v(_vm._s(_vm.$t("settingsTabTimeManagement"))),
                      ]),
                      _c("v-tab", [
                        _vm._v(_vm._s(_vm.$t("settingsTabProjects"))),
                      ]),
                      _c("v-tab", [
                        _vm._v(_vm._s(_vm.$t("settingsTabServiceCalls"))),
                      ]),
                      _c("v-tab", [
                        _vm._v(_vm._s(_vm.$t("settingsTabBusinessTrips"))),
                      ]),
                      _c("v-tab", [
                        _vm._v(_vm._s(_vm.$t("settingsTabCalculation"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-sheet",
                    {
                      staticClass: "pa-0",
                      attrs: {
                        color: _vm.$vuetify.theme.dark ? "#2E2E2E" : "white",
                        elevation: "0",
                      },
                    },
                    [
                      _c(
                        "v-tabs-items",
                        {
                          staticClass: "settings-tabs",
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            { staticClass: "mx-4" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 pt-4 align-center",
                                  style: _vm.rowStyle("g1"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("g1")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "4" },
                                    },
                                    [_vm._v(" " + _vm._s("Logo"))]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "align-center",
                                          attrs: {
                                            "no-gutters": "",
                                            justify: "end",
                                          },
                                        },
                                        [
                                          _c("input", {
                                            key: _vm.refresh,
                                            ref: "file",
                                            staticClass: "settings-file-input",
                                            attrs: {
                                              type: "file",
                                              id: "file",
                                              accept:
                                                "image/png, image/jpeg, image/jpg",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.handleFileUpload()
                                              },
                                            },
                                          }),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: {
                                                top: "",
                                                color: "primary",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "primary--text",
                                                              staticStyle: {
                                                                cursor:
                                                                  "pointer",
                                                                width: "20px",
                                                                "text-align":
                                                                  "center",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.resetLogo,
                                                              },
                                                            },
                                                            "div",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [_vm._v(" x ")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ]),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("resetLogo"))
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("g2"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("g2")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center font-weight-regular",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(this.$t("messagesLanguage")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          dense: "",
                                          items: _vm.languages,
                                          label: _vm.$t(
                                            "language_picker_helper"
                                          ),
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.selectedLanguage,
                                          callback: function ($$v) {
                                            _vm.selectedLanguage = $$v
                                          },
                                          expression: "selectedLanguage",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("g3"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("g3")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(this.$t("defaultState")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          dense: "",
                                          items: _vm.states,
                                          "item-text": "name",
                                          "item-value": "value",
                                          label: _vm.$t("defaultState"),
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.selectedState,
                                          callback: function ($$v) {
                                            _vm.selectedState = $$v
                                          },
                                          expression: "selectedState",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-0 align-center",
                                  style: _vm.rowStyle("g4"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("g4")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(this.$t("showCostCentre")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.showCostCentreOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value: _vm.showCostCentreOn,
                                          callback: function ($$v) {
                                            _vm.showCostCentreOn = $$v
                                          },
                                          expression: "showCostCentreOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("g5"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("g5")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(this.$t("requireLocation")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.requireLocationOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value: _vm.requireLocationOn,
                                          callback: function ($$v) {
                                            _vm.requireLocationOn = $$v
                                          },
                                          expression: "requireLocationOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("g6"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("g6")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          this.$t("automaticLocationByRFID")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.automaticLocationByRFIDOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value: _vm.automaticLocationByRFIDOn,
                                          callback: function ($$v) {
                                            _vm.automaticLocationByRFIDOn = $$v
                                          },
                                          expression:
                                            "automaticLocationByRFIDOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("g7"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("g7")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(this.$t("absenceForSickKPI")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          dense: "",
                                          items: _vm.absences,
                                          "item-text": "name",
                                          "item-value": "id",
                                          label: _vm.$t("absenceForSickKPI"),
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.absenceForSickKPI,
                                          callback: function ($$v) {
                                            _vm.absenceForSickKPI = $$v
                                          },
                                          expression: "absenceForSickKPI",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            { staticClass: "mx-4" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-3 align-center",
                                  style: _vm.rowStyle("s1"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("s1")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("resetAdminPassword")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "textColor--white buttonHoverOpacity",
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              _vm.userPasswordChangeDialog = true
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("resetPassword")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _vm.userPasswordChangeDialog
                                        ? _c("ResetPassword", {
                                            attrs: {
                                              newpasswordonlogin: true,
                                              empid: "0000",
                                            },
                                            on: {
                                              finished: function ($event) {
                                                _vm.userPasswordChangeDialog = false
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            { staticClass: "mx-4" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("tm1"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("tm1")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t("allowUserCloseOpenBooking")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.allowUserCloseOpenBookingOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value:
                                            _vm.allowUserCloseOpenBookingOn,
                                          callback: function ($$v) {
                                            _vm.allowUserCloseOpenBookingOn =
                                              $$v
                                          },
                                          expression:
                                            "allowUserCloseOpenBookingOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("tm2"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("tm2")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t("automaticCloseOpenBooking")
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            bottom: "",
                                            color: "primary",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        staticClass: "ml-2",
                                                        style: {
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.showHelpDialog = true
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [_vm._v("mdi-help")]
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c("span", {}, [
                                            _vm._v(_vm._s(_vm.$t("help"))),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.automaticCloseOpenBookingOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value:
                                            _vm.automaticCloseOpenBookingOn,
                                          callback: function ($$v) {
                                            _vm.automaticCloseOpenBookingOn =
                                              $$v
                                          },
                                          expression:
                                            "automaticCloseOpenBookingOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("tm3"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("tm3")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t(
                                              "hideCommentByTimeCorrection"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.hideCommentByTimeCorrectionOn ==
                                            1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value:
                                            _vm.hideCommentByTimeCorrectionOn,
                                          callback: function ($$v) {
                                            _vm.hideCommentByTimeCorrectionOn =
                                              $$v
                                          },
                                          expression:
                                            "hideCommentByTimeCorrectionOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            { staticClass: "mx-4" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("p1"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("p1")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t("stageProjectsAllowed")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.stageProjectsOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value: _vm.stageProjectsOn,
                                          callback: function ($$v) {
                                            _vm.stageProjectsOn = $$v
                                          },
                                          expression: "stageProjectsOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("p2"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("p2")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t(
                                              "stageProjectsWithoutPermissions"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.stageProjectsAllRightsOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value: _vm.stageProjectsAllRightsOn,
                                          callback: function ($$v) {
                                            _vm.stageProjectsAllRightsOn = $$v
                                          },
                                          expression:
                                            "stageProjectsAllRightsOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("p3"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("p3")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t(
                                              "showFinanceProjectByProjectManagement"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.showFinanceProjectByProjectManagement ==
                                            1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value:
                                            _vm.showFinanceProjectByProjectManagement,
                                          callback: function ($$v) {
                                            _vm.showFinanceProjectByProjectManagement =
                                              $$v
                                          },
                                          expression:
                                            "showFinanceProjectByProjectManagement",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("p4"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("p4")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t("financeProjectsAllowed")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.financeProjectsOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value: _vm.financeProjectsOn,
                                          callback: function ($$v) {
                                            _vm.financeProjectsOn = $$v
                                          },
                                          expression: "financeProjectsOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("p5"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("p5")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t("allowProjectComment")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.projectCommentOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value: _vm.projectCommentOn,
                                          callback: function ($$v) {
                                            _vm.projectCommentOn = $$v
                                          },
                                          expression: "projectCommentOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            { staticClass: "mx-4" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("sc1"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("sc1")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t("serviceCallsAllowed")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.serviceCallsOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value: _vm.serviceCallsOn,
                                          callback: function ($$v) {
                                            _vm.serviceCallsOn = $$v
                                          },
                                          expression: "serviceCallsOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("sc2"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("sc2")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t(
                                              "serviceCallsWithoutPermissions"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.serviceCallsAllRightsOn == 1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value: _vm.serviceCallsAllRightsOn,
                                          callback: function ($$v) {
                                            _vm.serviceCallsAllRightsOn = $$v
                                          },
                                          expression: "serviceCallsAllRightsOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            { staticClass: "mx-4" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("bt1"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("bt1")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t(
                                              "showBusinessTripByTimeKeeping"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.showBusinessTripByTimeKeeping ==
                                            1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value:
                                            _vm.showBusinessTripByTimeKeeping,
                                          callback: function ($$v) {
                                            _vm.showBusinessTripByTimeKeeping =
                                              $$v
                                          },
                                          expression:
                                            "showBusinessTripByTimeKeeping",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("bt2"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("bt2")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            this.$t(
                                              "showBusinessTripByTimeKeepingOnlyIfItsApproved"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          dense: "",
                                          color: "primary",
                                          "true-value": 1,
                                          "false-value": 0,
                                          "hide-details": "",
                                          label:
                                            _vm.showBusinessTripByTimeKeepingOnlyIfItsApproved ==
                                            1
                                              ? _vm.$t("yes")
                                              : _vm.$t("no"),
                                        },
                                        model: {
                                          value:
                                            _vm.showBusinessTripByTimeKeepingOnlyIfItsApproved,
                                          callback: function ($$v) {
                                            _vm.showBusinessTripByTimeKeepingOnlyIfItsApproved =
                                              $$v
                                          },
                                          expression:
                                            "showBusinessTripByTimeKeepingOnlyIfItsApproved",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            { staticClass: "mx-4" },
                            [
                              _c(
                                "v-overlay",
                                {
                                  attrs: {
                                    value: _vm.timeAccountLoader,
                                    absolute: true,
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "center" } },
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          staticStyle: { color: "black" },
                                          attrs: { color: "white" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "timeAccountsRecalculateAlert"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-3 align-center",
                                  style: _vm.rowStyle("sCalc"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("sCalc")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("TimeAccountRecalculation")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "textColor--text buttonHoverOpacity",
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              _vm.showRecalculateDialog = true
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "startTimeAccountRecalculation"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "py-2 align-center",
                                  style: _vm.rowStyle("c2"),
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEnter("c2")
                                    },
                                    mouseleave: _vm.hoverLeave,
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "caption orange--text mt-2",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "timeAccountsWarningText"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "w-100",
                      attrs: { "no-gutters": "", align: "center" },
                    },
                    [
                      _c(
                        "v-column",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "pa-0 pl-7",
                              attrs: { justify: "start", "no-gutters": "" },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "COBI.time Version: " + _vm._s(_vm.$version)
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-column",
                        { staticClass: "py-3" },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "pa-0 pr-7",
                              attrs: { justify: "end", "no-gutters": "" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "textColor--white buttonHoverOpacity",
                                  attrs: { color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveSettings()
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showHelpDialog
        ? _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "650" },
              on: {
                "click:outside": function ($event) {
                  _vm.showHelpDialog = false
                },
              },
              model: {
                value: _vm.showHelpDialog,
                callback: function ($$v) {
                  _vm.showHelpDialog = $$v
                },
                expression: "showHelpDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline justify-center" },
                    [
                      _c("p", { staticClass: "primary--text mb-0" }, [
                        _vm._v(
                          _vm._s(_vm.$t("automaticCloseOpenBookingHelpTitle"))
                        ),
                      ]),
                    ]
                  ),
                  _c("v-card-text", [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("automaticCloseOpenBookingHelp")
                        ),
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { width: "500px" },
          model: {
            value: _vm.showRecalculateDialog,
            callback: function ($$v) {
              _vm.showRecalculateDialog = $$v
            },
            expression: "showRecalculateDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("div", [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("startRecalculationRequest"))),
                  ]),
                ]),
              ]),
              _c("v-card-text", [
                _vm._v(_vm._s(_vm.$t("timeAccountsWarningGeneral"))),
              ]),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "center", "no-gutters": "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary darken-1" },
                          on: { click: _vm.recalculateTimeAccounts },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { attrs: { justify: "center", "no-gutters": "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary darken-1" },
                          on: {
                            click: function ($event) {
                              _vm.showRecalculateDialog = false
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }